<template>
	<!-- Shape of pages/resources.vue: page header, grey section bar, card grid. -->
	<div aria-hidden="true">
		<!-- NOT `:search="true"`. The library's search field lives in
		     LibraryFilters, not the page header — pages/resources.vue passes no
		     `v-model`, so `searchEnabled` is false and the real header renders no
		     input. Reserving one here made the skeleton ~68px taller than the
		     header that replaced it, which is a visible drop on every load. -->
		<PageHeaderSkeleton :subtitle-lines="2" />

		<!-- Grey section / filter bar -->
		<div class="bg-gray-200 dark:bg-gray-800/50 py-8 md:py-14 flex justify-center p-4 md:px-8">
			<div class="w-full max-w-7xl flex justify-center md:justify-start">
				<div class="flex items-center space-x-6 md:space-x-16">
					<Skeleton v-for="n in 5" :key="n" class="h-5 md:h-6 w-14 md:w-20" />
				</div>
			</div>
		</div>

		<!-- Resource card grid -->
		<div class="w-full flex flex-col items-center justify-start p-4 md:px-8 md:py-16">
			<div class="w-full max-w-7xl">
				<Skeleton class="h-5 w-28 my-4 ml-2" />
				<div class="grid gap-4 md:gap-8 xl:gap-12 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
					<div v-for="n in 8" :key="n" class="w-full">
						<Skeleton rounded="rounded-lg" class="w-full aspect-video" />
						<Skeleton class="h-4 w-5/6 mt-3" />
						<Skeleton class="h-3 w-1/2 mt-2" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Skeleton from '../skeleton.vue'
import PageHeaderSkeleton from './page-header-skeleton.vue'

export default {
	name: 'ResourcesSkeleton',
	components: { Skeleton, PageHeaderSkeleton },
}
</script>
